let runtime;
async function get() {
    // @ts-expect-error
    const { get } = await import('virtual:oswald-configuration');
    runtime = await get();
}
function getConfiguration() {
    return runtime;
}
void get();
export { getConfiguration, };
//# sourceMappingURL=configuration.js.map